// src/pages/Offerings.js
import React, { useEffect } from 'react';
import './Offerings.css';
import {
  FaCode, FaMobileAlt, FaBrain, FaChalkboardTeacher,
  FaRobot, FaCalendarCheck, FaHome
} from 'react-icons/fa';

const services = [
  {
    title: "Web Development",
    description: "Modern, responsive, and scalable web applications built using the latest technologies.",
    icon: <FaCode />,
    color: "#1a73e8",
    tag: "Web"
  },
  {
    title: "Mobile App Development",
    description: "Cross-platform mobile apps with seamless performance and user-friendly design.",
    icon: <FaMobileAlt />,
    color: "#34a853",
    tag: "Mobile"
  },
  {
    title: "AI Solutions",
    description: "Intelligent AI-powered solutions tailored to your business needs.",
    icon: <FaBrain />,
    color: "#ea4335",
    tag: "AI"
  },
  {
    title: "Trainings & Bootcamps",
    description: "Hands-on training programs and bootcamps to upskill in modern software technologies.",
    icon: <FaChalkboardTeacher />,
    color: "#fbbc05",
    tag: "Training"
  }
];

const products = [
  {
    title: "Chatbot",
    description: "An AI-powered chatbot to automate conversations and customer support.",
    icon: <FaRobot />,
    color: "#8b5cf6",
    tag: "AI",
    comingSoon: true
  },
  {
    title: "Smart Appointment System",
    description: "A streamlined platform for booking, managing, and tracking appointments across services.",
    icon: <FaCalendarCheck />,
    color: "#3b82f6",
    tag: "Scheduling"
  },
  {
    title: "Community Connect Portal",
    description: "A community-driven site for rural development, local updates, and digital access to services.",
    icon: <FaHome />,
    color: "#f97316",
    tag: "Community"
  }
];

const Offerings = () => {
  useEffect(() => {
    const cards = document.querySelectorAll('.offering-card');
    cards.forEach((card, i) => {
      card.style.animationDelay = `${i * 0.1}s`;
      card.classList.add('fade-in');
    });
  }, []);

  const scrollToBottom = () => {
    window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
  };

  return (
    <div className="offerings-page">
      {/* Hero Section */}
      <section className="offerings-hero">
        <h1>Our Products & Services</h1>
        <p>
          At <span className="brand">Talyfax</span>, we deliver cutting-edge solutions to empower 
          businesses and individuals. From web & mobile development to AI-powered innovations and 
          professional training, we’ve got you covered.
        </p>
      </section>

      {/* Services Section */}
      <section className="offerings-section">
        <h2>Our Services</h2>
        <div className="offerings-grid">
          {services.map((service, idx) => (
            <div
              key={idx}
              className="offering-card"
              style={{ '--glow-color': service.color }}
            >
              <div
                className="offering-icon-wrapper"
                style={{ backgroundColor: `${service.color}1A` }}
              >
                <span className="offering-icon" style={{ color: service.color }}>
                  {service.icon}
                </span>
              </div>
              <h3>{service.title}</h3>
              <p>{service.description}</p>
              <span className="card-tag">{service.tag}</span>
            </div>
          ))}
        </div>
      </section>

      {/* Divider */}
      <div className="section-divider"></div>

      {/* Products Section */}
      <section className="offerings-section">
        <h2>Our Products</h2>
        <div className="offerings-grid">
          {products.map((product, idx) => (
            <div
              key={idx}
              className={`offering-card ${product.comingSoon ? 'upcoming' : ''}`}
              style={{ '--glow-color': product.color }}
            >
              <div
                className="offering-icon-wrapper"
                style={{ backgroundColor: `${product.color}1A` }}
              >
                <span className="offering-icon" style={{ color: product.color }}>
                  {product.icon}
                </span>
              </div>
              <h3>{product.title}</h3>
              <p>{product.description}</p>
              <span className="card-tag">{product.tag}</span>
              {product.comingSoon && <span className="coming-soon">Coming Soon</span>}
            </div>
          ))}
        </div>
      </section>

      {/* Divider */}
      <div className="section-divider"></div>

      {/* Floating CTA */}
      <button className="floating-cta" onClick={scrollToBottom}>
        Let’s Build Together 🚀
      </button>
    </div>
  );
};

export default Offerings;
